import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';

if($('#vue').length >= 1) {
	createInertiaApp({
		id: 'vue',
		title: (title) => `${title}`,
		resolve: name => require(`@vvg/forum/vue/${name}`),
		setup({ el, App, props, plugin }) {
			return createApp({ render: () => h(App, props) })
				.use(plugin)
				.mount(el);
		},
		progress: {
			color: '#4B5563',
		},
	});

}